module.exports = __webpack_public_path__ + "static/img_4589-dbaa1ac7ed8020d6eb04af373933d9e0.webp";